/* eslint-disable */
/**
 * AWS Cognito Configuration
 *
 * Session storage: Amplify uses default (localStorage) so that:
 * - New tabs in the same origin stay logged in
 * - Page refresh restores the session
 * Without this, MemoryStorage was used so session lived only in one tab's memory,
 * causing "logged out" when opening a new tab and multiple reloads.
 */

//prod
const prodProps = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:4225a2f4-9cbe-41a2-9ab1-55fbe11fc575",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_K0mvX10GW",
    "aws_user_pools_web_client_id": "59hhcnlrc5nmakpcd2ipmp0oog",
    "oauth": {}
};

//sandbox
const sandboxProps = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:7daf2a72-49ca-4443-ba14-d4842241734f",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_aKkiDQNyQ",
    "aws_user_pools_web_client_id": "6tan4q3jfm7btph2hqms6odm7f",
    "oauth": {}
};

const baseConfig = process.env.REACT_APP_ENV?.toUpperCase() === 'SANDBOX' ? sandboxProps : prodProps;

// Use Amplify default storage (localStorage) so new tabs and refresh restore session
const awsCognitoConfig = { ...baseConfig };

export default awsCognitoConfig;
